var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoConditionVerification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_verification",
    d: "M269.47,34.781l-6.125-2.7a.855.855,0,0,0-.691,0l-6.125,2.7a.9.9,0,0,0-.529.826v3.6c0,4.952,1.78,7.847,6.564,10.682a.858.858,0,0,0,.871,0C268.22,47.061,270,44.167,270,39.207v-3.6A.9.9,0,0,0,269.47,34.781Zm-3.16,4.09-3.5,4.5a.875.875,0,0,1-.684.337h-.037a.873.873,0,0,1-.691-.4l-1.75-2.7a.915.915,0,0,1,.243-1.247.86.86,0,0,1,1.213.25l1.087,1.676,2.751-3.539a.862.862,0,0,1,1.23-.14A.918.918,0,0,1,266.309,38.871Z",
    transform: "translate(-256 -32.008)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoConditionVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_condition_verification.1e8164a73a41d237cf888c4e0691e4bf.svg";